import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!this.element.classList.contains('draggable')) return;

    this.element.setAttribute('draggable', 'true');
    this.element.addEventListener('dragstart', this.dragStart.bind(this));
    this.element.addEventListener('dragover', this.dragOver.bind(this));
    this.element.addEventListener('dragenter', this.dragEnter.bind(this));
    this.element.addEventListener('dragleave', this.dragLeave.bind(this));
    this.element.addEventListener('drop', this.drop.bind(this));
    this.element.addEventListener('dragend', this.dragEnd.bind(this));
  }

  disconnect() {
    if (!this.element.classList.contains('draggable')) return;

    this.element.removeAttribute('draggable');
    this.element.removeEventListener('dragstart', this.dragStart);
    this.element.removeEventListener('dragover', this.dragOver);
    this.element.removeEventListener('dragenter', this.dragEnter);
    this.element.removeEventListener('dragleave', this.dragLeave);
    this.element.removeEventListener('drop', this.drop);
    this.element.removeEventListener('dragend', this.dragEnd);
  }

  dragStart(event) {
    event.dataTransfer.setData('text/plain', this.element.dataset.issueId);
    this.element.classList.add('dragging');
  }

  dragOver(event) {
    event.preventDefault();
  }

  dragEnter(event) {
    event.preventDefault();
    this.element.classList.add('drag-over');
  }

  dragLeave() {
    this.element.classList.remove('drag-over');
  }

  drop(event) {
    event.preventDefault();
    const issueId = event.dataTransfer.getData('text/plain');
    const draggedElement = document.querySelector(`[data-issue-id="${issueId}"]`);

    if (draggedElement === this.element) return;

    const container = this.element.parentNode;
    const status = container.dataset.status;

    // Get all draggable elements in the container
    const draggableElements = Array.from(container.querySelectorAll('.draggable'));

    // Find the index of the drop target
    const dropIndex = draggableElements.indexOf(this.element);

    // Send AJAX request to update positions
    this.updatePosition(issueId, dropIndex);

    this.element.classList.remove('drag-over');
  }

  dragEnd() {
    document.querySelectorAll('.dragging').forEach(el => {
      el.classList.remove('dragging');
    });
    document.querySelectorAll('.drag-over').forEach(el => {
      el.classList.remove('drag-over');
    });
  }

  updatePosition(issueId, newPosition) {
    const projectId = window.location.pathname.split('/')[2]; // Extract project ID from URL

    fetch(`/projects/${projectId}/roadmaps/reorder`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        issue_id: issueId,
        position: newPosition
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to update position');
      }
      // Reload the page to reflect the new order
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating position:', error);
    });
  }
}
